module.exports = __webpack_public_path__ + "img/appQrcode_sit.3fbccb01.jpg";